import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import AuthContext from '../../context/authentication/authContext';
import Aviso from "../modal/Aviso";
import Alerta from "../modal/Alerta";
import axiosClient from '../../config/axiosClient';
import loader from "../../img/ajax-loader.gif";
import { diasPorMes, numMes, monthBirthdateOptions, yearBirthdateOptions, yearOptions, areaOptions, industryOptions } from "./SelectOptions";

const Alumno = (props) => {

    const authToken = useContext(AuthContext);
    const { user, editarUsuario } = authToken;

    useEffect(() => {
        if ( user ) {
            setStudent(user);
            const [d, m, y] = user.birth_date.split('/');
            document.getElementById('dia').value = d;
            document.getElementById('mes').value = m;
            document.getElementById('anio').value = y;
            if ( user.profile !== 'Student') {
                props.history.push('/mentorias');
            }
            //console.log(d + y + m)
        }
        if (location.pathname === '/editStudent'){
            document.getElementById("email").readOnly = true;
            document.getElementById("password").required = false;
            document.getElementById("confirm_password").required = false;
        }
        // eslint-disable-next-line
    }, [user])

    const [ student, setStudent ] = useState({
        profile: 'Student',
        name: '',
        last_name: '',
        birth_date: '',
        birth_date_complement: '',
        phone: '',
        email: '',
        password: '',
        confirm_password: '',
        //photo: '',
        career: '',
        year: '',
        mention: '',
        residence: false,
        company: '',
        functions: '',
        industry: [],
        area: [],
        goals: '',
        area_reasons: '', 
        extra_studies: '',
        concerns: '',
        projection: '',
        hobbies: '',
        expectatives: '',
        needs: ''
    });

    const location = useLocation();

    var dias = []; 

    const [ aceptoTerminos, setAceptoTerminos ] = useState(false);
    const [ showAviso, setShowAviso ] = useState(false);
    const [ showAlerta, setShowAlerta] = useState(false);
    const [ msg, setMsg ] = useState("");
    const [ mes, setMes ] = useState("Enero");

    const { name, last_name, birth_date, phone, email, password, confirm_password, /* photo, */ career, year, mention, residence, company, functions, industry, area, goals, area_reasons, extra_studies, concerns, projection, hobbies, expectatives, needs } = student;

    const onChange = e => {
        setStudent({
            ...student,
            [e.target.name]: e.target.value
        })
    }

    const onChangeMes = e => {
        setMes(e.target.value)

        crearDias();
    }

    const onchangeMultiple = e => {
        let values = Array.from(e.target.selectedOptions, option => option.value);
        
        setStudent({
            ...student,
            [e.target.name]: values
        })
    }

    console.log(student)

    const onClick = e => {
        setStudent({
            ...student,
            [e.target.name]: e.target.checked
        })
    }

    const onSubmit = e => {
        e.preventDefault();

        if (location.pathname === '/alumnosRegistro'){
            if ( name.trim() === '' || last_name.trim === '' || birth_date.trim === '' || phone.trim().trim === ''  || email.trim().trim === '' || password.trim() === '' || confirm_password === ''  || career.trim().trim === '' || year.trim().trim === '' || mention.trim().trim === '' || area_reasons.trim().trim === '' || extra_studies.trim === '' || goals.trim().trim === '' || concerns.trim === '' || projection.trim === '' || expectatives.trim === '' || needs.trim === '') {
                setMsg("Revise que la información esté correcta");
                setShowAlerta(true);
                return;
            }

            let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
            // Validar que el email sea correcto
            if ( !emailRegex.test(email) ) {
                setMsg("El email está mal escrito");
                setShowAlerta(true);
                document.getElementById("email").focus()
                return;
            }
            // Password minimo 6 Caracteres
            if ( password.length < 6 ) {
                setMsg("La contraseña debe contener al menos 6 caracteres");
                setShowAlerta(true);
                document.getElementById("password").focus()
                return;
            }
            // Passwords Iguales
            if ( password !== confirm_password ) {
                setMsg("No coinciden las contraseñas introducidas");
                setShowAlerta(true);
                document.getElementById("confirm_password").focus()
                return;
            }
        } else {
            if (password && password.length > 1) {
                if ( password.length < 6 ) {
                    setMsg("La contraseña debe contener al menos 6 caracteres");
                    setShowAlerta(true);
                    document.getElementById("password").focus()
                    return;
                }
                // Passwords Iguales
                if ( password !== confirm_password ) {
                    setMsg("No coinciden las contraseñas introducidas");
                    setShowAlerta(true);
                    document.getElementById("confirm_password").focus()
                    return;
                }
            }
        }

        if ( residence ) {
            if ( company === '' ) {
                setMsg("Falta que indiques la empresa donde realizaste la práctica profesional");
                setShowAlerta(true);
                document.getElementById("company").focus()
                return;
            }
            if ( functions === '' ) {
                setMsg("Falta que indiques las funciones desempeñadas en tu práctica profesional");
                setShowAlerta(true);
                document.getElementById("functions").focus()
                return;
            }
        } else {
            student['company'] = '';
            student['functions'] = '';
        }

        student['birth_date'] = document.getElementById('dia').value + '/' + document.getElementById('mes').value + '/' + document.getElementById('anio').value;

        student['birth_date_complement'] = new Date(document.getElementById('anio').value, numMes[mes], document.getElementById('dia').value).toISOString();

        setMsg(<label><img src={loader} alt="loader" /> Procesando...</label>)
        setShowAlerta(true)

        if (location.pathname === '/alumnosRegistro') {
            agregarStudent(student).then(setShowAlerta(true));
        }   else {
            editarStudent(student).then(editarUsuario(student)).then(setShowAlerta(true));
        }
    }

    const agregarStudent = async student => {
        try {
            const resultado = await axiosClient.post('/api/student', student);
            setMsg(resultado.data.msg);
        } catch (error) {
            console.log(error);
            setMsg("❗ Ocurrió un error en el servidor");
        }
    }

    const editarStudent = async student => {
        try {
            const resultado = await axiosClient.put('/api/student', student);
            setMsg(resultado.data.msg);
        } catch (error) {
            console.log(error);
            setMsg("❗ Ocurrió un error en el servidor");
        }
    }

    function crearDias(){
        dias = [];

        let month = diasPorMes[mes]

        for (let i = 1; i <= month; i++)
            dias.push(i);
    }

    crearDias();

    return (
        <div className="container">
            { showAviso && <Aviso isOpen={showAviso} onClose={() => setShowAviso(false)} /> }
            { showAlerta && <Alerta isOpen={showAlerta} onClose={() => setShowAlerta(false)} infoMsg={msg} /> }
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className="card">
                        <div className="card-header border-bottom">
                            { location.pathname==='/alumnosRegistro' ? (
                                <h3 className="card-title text-center">Registro de Alumno</h3>
                            ) : (
                                <h4 className="m-0">Edición de Perfil</h4>
                            )}
                        </div>
                        <div className="card-body">
                            <div className="card-text">
                                <form onSubmit={onSubmit}>
                                    <div className="row">

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <h4>Datos personales</h4>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="name">Nombre</label>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="name"
                                                    name="name"
                                                    title="Nombre"
                                                    placeholder="Nombre"
                                                    className="form-control form-control-sm"
                                                    value={name}
                                                    onChange={onChange}
                                                    required />
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="last_name">Apellido</label>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="last_name"
                                                    name="last_name"
                                                    title="Apellido"
                                                    placeholder="Apellido"
                                                    className="form-control form-control-sm"
                                                    value={last_name}
                                                    onChange={onChange}
                                                    required />
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="birth_date">Fecha de nacimiento</label>
                                            <div className="form-group">
                                                <select
                                                    name="mes"
                                                    id="mes"
                                                    className="form-control form-control-sm date-month"
                                                    title="mes"
                                                    onChange={onChangeMes}
                                                    required >
                                                        <option value="" disabled="disabled">Mes</option>
                                                        { monthBirthdateOptions.map((item) => { return (
                                                            <option value={item.value}>{item.value}</option>
                                                        )})}
                                                </select>

                                                <select
                                                    name="dia"
                                                    id="dia"
                                                    className="form-control form-control-sm date-day"
                                                    title="día"
                                                    required >
                                                        <option value="" disabled="disabled">Día</option>
                                                        {
                                                            dias.map((item, index) => <option value={item} key={index}>{item}</option>)
                                                        }
                                                </select>

                                                <select
                                                    name="anio"
                                                    id="anio"
                                                    className="form-control form-control-sm date-year"
                                                    title="anio"
                                                    onChange={onChange}
                                                    required >
                                                        <option value="" disabled="disabled">Año</option>
                                                        { yearBirthdateOptions.map((item) => { return (
                                                            <option value={item}>{item}</option>
                                                        )})}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="phone">Número telefónico</label>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="phone"
                                                    name="phone"
                                                    title="Número telefónico"
                                                    placeholder="Número telefónico"
                                                    className="form-control form-control-sm"
                                                    value={phone}
                                                    onChange={onChange}
                                                    required />
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="email">E-mail</label>
                                            <div className="form-group">
                                                <input
                                                    type="email"
                                                    id="email"
                                                    name="email"
                                                    title="E-mail"
                                                    placeholder="E-mail"
                                                    className="form-control form-control-sm"
                                                    value={email}
                                                    onChange={onChange}
                                                    required />
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="password">Contraseña</label>
                                            <div className="form-group">
                                                <input
                                                    type="password"
                                                    id="password"
                                                    name="password"
                                                    title="Contraseña"
                                                    placeholder="Contraseña"
                                                    className="form-control form-control-sm"
                                                    value={password}
                                                    onChange={onChange}
                                                    required
                                                    minLength="6" />
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="confirm_password">Confirme la contraseña</label>
                                            <div className="form-group">
                                                <input
                                                    type="password"
                                                    id="confirm_password"
                                                    name="confirm_password"
                                                    title="Confirme la contraseña"
                                                    placeholder="Confirme la contraseña"
                                                    className="form-control form-control-sm"
                                                    value={confirm_password}
                                                    onChange={onChange}
                                                    required
                                                    minLength="6" />
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <h4>Información académica</h4>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <label htmlFor="career">Carrera</label>
                                            <div className="form-group">
                                                <input
                                                    type="text"
                                                    id="career"
                                                    name="career"
                                                    title="Carrera"
                                                    placeholder="Carrera"
                                                    className="form-control form-control-sm"
                                                    value={career}
                                                    onChange={onChange}
                                                    required />
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="year">Año en curso</label>
                                            <div className="form-group">
                                                <select
                                                    name="year"
                                                    className="form-control form-control-sm"
                                                    title="Año en curso"
                                                    value={year}
                                                    onChange={onChange}
                                                    required >
                                                    <option value="" disabled="disabled">Año en curso</option>
                                                    { yearOptions.map((item) => { return (
                                                        <option value={item.value}>{item.value}</option>
                                                    )})}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="mention">Mención</label>
                                            <div className="form-group">
                                                <select
                                                    name="mention"
                                                    className="form-control form-control-sm"
                                                    title="Mención"
                                                    value={mention}
                                                    onChange={onChange}
                                                    required >
                                                    <option value="" disabled="disabled">Seleccione la mención...</option>
                                                    <option value="Administración">Administración</option>
                                                    <option value="Economía">Economía</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label>
                                                    <input
                                                        type="checkbox"
                                                        id="residence"
                                                        name="residence"
                                                        value={residence}
                                                        onClick={onClick} /> ¿Ya realizaste tu práctica profesional?</label>
                                            </div>
                                        </div>

                                        { residence && (
                                            
                                            <>
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <label htmlFor="company">Empresa</label>
                                                <div className="form-group">
                                                    <input
                                                        type="text"
                                                        id="company"
                                                        name="company"
                                                        title="Empresa"
                                                        placeholder="Empresa"
                                                        className="form-control form-control-sm"
                                                        value={company}
                                                        onChange={onChange} />
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <label htmlFor="functions">Funciones desempeñadas</label>
                                                <div className="form-group">
                                                    <textarea
                                                        type="text"
                                                        id="functions"
                                                        className="form-control form-control-sm"
                                                        rows="3"
                                                        title="Funciones desempeñadas"
                                                        placeholder="Funciones desempeñadas"
                                                        name="functions"
                                                        value={functions}
                                                        onChange={onChange} >
                                                        </textarea>
                                                </div>
                                            </div>
                                            </>
                                        )}

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <h4>Proyección a futuro</h4>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label className="alert alert-info" role="alert">❕ Para selección múltiple usa la tecla Ctrl o Cmd y selecciona las opciones deseadas</label>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="industry">Industria de tu interés</label>
                                            <div className="form-group">
                                                <select
                                                    name="industry"
                                                    className="form-control form-control-sm"
                                                    title="Industria de su interés"
                                                    value={industry}
                                                    onChange={onchangeMultiple}
                                                    multiple
                                                    required >
                                                    <option value="" disabled="disabled">Selecciona la(s) industria(s) de tu elección</option>
                                                    { industryOptions.map((item) => { return (
                                                        <option value={item.value}>{item.value}</option>
                                                    )})}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-6 col-xs-12">
                                            <label htmlFor="area">Áreas</label>
                                            <div className="form-group">
                                                <select
                                                    name="area"
                                                    className="form-control form-control-sm"
                                                    title="Áreas"
                                                    value={area}
                                                    onChange={onchangeMultiple}
                                                    multiple
                                                    required >
                                                    <option value="" disabled="disabled">Selecciona la(s) área(s) de tu elección</option>
                                                    { areaOptions.map((item) => { return (
                                                        <option value={item.value}>{item.value}</option>
                                                    )})}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="area_reasons">¿Por qué descartaste las otras áreas?</label>
                                            <div className="form-group">
                                                <textarea
                                                    type="text"
                                                    id="area_reasons"
                                                    className="form-control form-control-sm"
                                                    rows="3"
                                                    title="¿Por qué descartaste las otras áreas?"
                                                    placeholder="¿Por qué descartaste las otras áreas?"
                                                    name="area_reasons"
                                                    value={area_reasons}
                                                    onChange={onChange}
                                                    required >
                                                    </textarea>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="extra_studies">¿Realizarías algún estudio al egresar?</label>
                                            <div className="form-group">
                                                <textarea
                                                    type="text"
                                                    id="extra_studies"
                                                    className="form-control form-control-sm"
                                                    rows="3"
                                                    title="¿Realizarías algún estudio al egresar?"
                                                    placeholder="¿Realizarías algún estudio al egresar?"
                                                    name="extra_studies"
                                                    value={extra_studies}
                                                    onChange={onChange}
                                                    required >
                                                    </textarea>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="goals">Metas profesionales</label>
                                            <div className="form-group">
                                                <textarea
                                                    type="text"
                                                    id="goals"
                                                    className="form-control form-control-sm"
                                                    rows="3"
                                                    title="Metas profesionales"
                                                    placeholder="Metas profesionales"
                                                    name="goals"
                                                    value={goals}
                                                    onChange={onChange}
                                                    required >
                                                    </textarea>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="concerns">Inquietudes principales</label>
                                            <div className="form-group">
                                                <textarea
                                                    type="text"
                                                    id="concerns"
                                                    className="form-control form-control-sm"
                                                    rows="3"
                                                    title="Inquietudes principales"
                                                    placeholder="¿Cuál es tu principal inquietud acerca del futuro laboral?"
                                                    name="concerns"
                                                    value={concerns}
                                                    onChange={onChange}
                                                    required >
                                                    </textarea>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <label htmlFor="projection">Proyección laboral a 5 años</label>
                                            <div className="form-group">
                                                <textarea
                                                    type="text"
                                                    id="projection"
                                                    className="form-control form-control-sm"
                                                    rows="3"
                                                    title="Proyección laboral a 5 años"
                                                    placeholder="Proyección laboral a 5 años"
                                                    name="projection"
                                                    value={projection}
                                                    onChange={onChange}
                                                    required >
                                                    </textarea>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <h4>Otros intereses (personales o profesionales)</h4>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <label htmlFor="hobbies">Hobbies, pasatiempos</label>
                                                <textarea
                                                    type="text"
                                                    id="hobbies"
                                                    className="form-control form-control-sm"
                                                    rows="2"
                                                    title="Hobbies, pasatiempos"
                                                    placeholder="Hobbies, pasatiempos"
                                                    name="hobbies"
                                                    value={hobbies}
                                                    onChange={onChange} >
                                                    </textarea>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="expectatives">¿Qué esperas del Programa?</label>
                                            <div className="form-group">
                                                <textarea
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    rows="3"
                                                    title="¿Qué esperas del Programa?"
                                                    placeholder="¿Qué esperas del Programa?"
                                                    name="expectatives"
                                                    value={expectatives}
                                                    onChange={onChange}
                                                    required >
                                                    </textarea>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-sm-12 col-xs-12">
                                            <label htmlFor="needs">¿Qué necesitas aprender?</label>
                                            <div className="form-group">
                                                <textarea
                                                    type="text"
                                                    className="form-control form-control-sm"
                                                    rows="3"
                                                    title="¿Qué necesitas aprender?"
                                                    placeholder="¿Qué necesitas aprender?"
                                                    name="needs"
                                                    value={needs}
                                                    onChange={onChange}
                                                    required >
                                                    </textarea>
                                            </div>
                                        </div>
                                    </div>

                                    { location.pathname==='/alumnosRegistro' ? (
                                        <>
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="form-group">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={() => setAceptoTerminos(!aceptoTerminos)}
                                                            onClick={() => setAceptoTerminos(!aceptoTerminos)} /> He leído y aceptado el&nbsp;</label><button type="button" className="btn-link" onClick={() => setShowAviso(true)} >Aviso de privacidad</button>
                                                </div>
                                            </div>
                                            { aceptoTerminos && (
                                                <button type="submit" className="btn btn-primary btn-block">Registrar</button>
                                            )}
                                            <div className="sign-up">
                                                <Link to={'/'} className="enlace-cuenta">
                                                    Iniciar sesión
                                                </Link>
                                            </div>
                                        </>
                                    ) : (
                                        <button type="submit" className="btn btn-primary" >Guardar</button>
                                    )}
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Alumno